// extracted by mini-css-extract-plugin
export default {"searchbar":"NewsSection_searchbar__xOgur"};